<template>
  <div>
    <h1 class="display-3">Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA</h1><br/>

    <b-row>
      <b-col lg="7" cols="11" order-lg="1" order="2">
        <p>
          Zakończyliśmy realizację projektu obejmującego opracowanie, digitalizację i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego (1925 – 2013). W jej skład wchodzą materiały dotyczące życia Jana Gozdawy-Gołębiowskiego, jego braci, również żołnierzy AK oraz materiały dokumentujące działania Armii Krajowej na terenie Obszaru Warszawskiego.
        </p>
        <p>
          Spuścizna została zinwentaryzowana w Otwartym Systemie Archiwizacji (OSA: <a href="https://osa.archiwa.org/">https://osa.archiwa.org/</a>). Można ją przeszukiwać przy użyciu wyszukiwarki.
        </p>
        <p>
          Inwentarz dostępny jest <a href="https://karta.org.pl/sites/default/files/attachments/inwentarz_kolekcji_jana_gozdawy-golebiowskiego.pdf">tutaj</a>, a z oryginałami można zapoznać w Archiwum Ośrodka KARTA.
        </p>
        <p>
          Zadanie publiczne: "Opracowanie, digitalizacja i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego - podchorążego w 2. Plutonie Kompanii Sztabowej Obszaru Warszawskiego AK "Koszta" jest współfinansowane ze środków otrzymanych od Urzędu do Spraw Kombatantów i Osób Represjonowanych.
        </p>
        <hr>
        <b-img fluid src="/aktualnosci/logo_UDSKiOR_male.jpg"/>

      </b-col>
      <b-col lg="5" order-lg="2" order="1">
        <b-img center fluid src="/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego.jpg"/><br/>
      </b-col>
    </b-row>

  </div>
</template>

<script>
export default {
  name: 'spuscizna_jana_gozdawy',
  metaInfo:{
    title: 'Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA',
    meta:[
      {name: 'description', content: 'Zakończyliśmy realizację projektu obejmującego opracowanie, digitalizację i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego (1925 – 2013)' },
      {name: 'og:url', content: 'http://ak-wilno.pl/spuscizna_jana_gozdawy_golebiowskiego' },
      {name: 'og:title', content: 'Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA' },
      {name: 'og:image', content: '/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego.jpg' },
      {name: 'og:description', content: 'Zakończyliśmy realizację projektu obejmującego opracowanie, digitalizację i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego (1925 – 2013)' },
      {name: 'twitter:url', content: 'http://ak-wilno.pl/spuscizna_jana_gozdawy_golebiowskiego' },
      {name: 'twitter:title', content: 'Spuścizna Jana Gozdawy-Gołębiowskiego udostępniona w OSA' },
      {name: 'witter:image', content: '/aktualnosci/spuscizna_jana_gozdawy_golebiowskiego.jpg' },
      {name: 'twitter:description', content: 'Zakończyliśmy realizację projektu obejmującego opracowanie, digitalizację i upowszechnienie kolekcji osobistej Jana Gozdawy-Gołębiowskiego (1925 – 2013)' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/aktualnosci/spuscizna_jana_gozdawy.vue